module.exports = __webpack_public_path__ + "img/person_2_index.1d036c27.png";